import styled, { keyframes } from "styled-components";

const grow = keyframes`
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(1);
  }
  50% {
    transform: scale(0);
  }
  75% {
    transform: scale(1);
    background: #C6DDFF;
  }
  100% {
    transform: scale(0);
    background: #C6DDFF;
  }
`;

const LoadingContainer1 = styled.div`
	position: relative;
	margin: 15px auto 35px auto;
	width: 80px;

	div {
		height: 13px;
		width: 13px;
		border-radius: 50%;
		background: black;
		float: left;
		margin: 0 3px;
		background: #3b84e3;
		transform: scale(0);
	}

	.ball1 {
		z-index: 1;
		animation: ${grow} 4.4s infinite ease-in-out;
	}

	.ball2 {
		animation: ${grow} 4.4s infinite ease-in-out;
		animation-delay: 0.3s;
	}

	.ball3 {
		animation: ${grow} 4.4s infinite ease-in-out;
		animation-delay: 0.6s;
	}

	.ball4 {
		animation: ${grow} 4.4s infinite ease-in-out;
		animation-delay: 0.9s;
	}
`;

function Loading() {
	return (
		<LoadingContainer1>
			<div className="ball1"></div>
			<div className="ball2"></div>
			<div className="ball3"></div>
			<div className="ball4"></div>
		</LoadingContainer1>
	);
}

export default Loading;
